import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder} from '../../../../lib/helpers';

export class ReorderLanguagesStore implements SaveStateHolder {
  @observable
  readonly languageIds: number[];

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(languageIds: number[]) {
    makeObservable(this);
    this.languageIds = languageIds;
    this.save = null;
  }

  @action
  complete = () => {
    if (this.save?.isPending === true)
      return;
    const reordered = this.languageIds.slice();
    this.save = contentLoaders.x1language.order(reordered);
  };

  @action
  swap(index1: number, index2: number) {
    let languageIds = this.languageIds;
    let tmp = languageIds[index1];
    languageIds[index1] = languageIds[index2];
    languageIds[index2] = tmp;
  }
}
